<div class="appointment-card">
  <h3 class="table-title">YOUR APPOINTMENTS FOR THIS LEAD</h3>
  <table class="custom-table">
    <thead>
      <tr>
        <th>Project</th>
        <th>Clients Name</th>
        <th>Appointment Time</th>
        <th>Appointment Type</th>
        <th>Agent</th>
        <th class="text-center">Attended</th>
        <th class="text-center">Liked</th>
      </tr>
    </thead>

    <tbody>
      <tr *ngFor="let appointment of project_appointment_list" class="cursor-pointer" (click)="editTableEvent(appointment); tabIndexValue = 1">
        <!-- Project -->
        <td>{{ appointment.project_name }}</td>

        <!-- Clients -->
        <td>
          <span *ngFor="let client of appointment?.clients; let i = index">
            {{ client.full_name }}{{ i < appointment.clients.length - 1 ? ', ' : '' }}
          </span>
        </td>

        <!-- Time -->
        <td>
          {{ appointment.event.start.dateTime | date: 'd MMM y' }}
          {{ getTimeFormat(appointment.event.start.dateTime) }} -
          {{ getTimeFormat(appointment.event.end.dateTime) }}
        </td>

        <!-- Type -->
        <td>{{ appointment.app_type }}</td>

        <!-- Agents -->
        <td>
          <span *ngFor="let agent of appointment?.agents">
            {{ agent.full_name }}
          </span>
        </td>

        <!-- Attended -->
        <td class="text-center">
          <span class="attendee-dot" [ngStyle]="{ 'background-color': appointment?.color }" [title]="appointment?.tooltip"> </span>
        </td>

        <!-- Likes -->
        <td class="text-center">
          <span *ngIf="appointment?.total_likes?.length > 0">👍</span>
          <span *ngIf="appointment?.total_dislikes?.length > 0">👎</span>
        </td>
      </tr>

      <tr *ngIf="!project_appointment_list || project_appointment_list.length === 0">
        <td colspan="7" class="text-center">No record found</td>
      </tr>
    </tbody>
  </table>
  <div class="mt-3">
    <p *ngIf="project_appointment_list?.length > 0" style="font-size: 10px !important">
      {{ project_appointment_list?.length == 1 ? 'Record: ' + project_appointment_list?.length : 'Records:' + project_appointment_list?.length }}
    </p>
  </div>
</div>

<div class="appointment-card mt-3">
  <div class="appointment_box">
    <div class="create_box" *ngIf="!emailConnected">
      <div class="d-flex w-400px align-items-center flex-wrap">
        <img [src]="common_images?.contact_calendar" class="mr-4 email-connect" />
        <div class="pt-3">
          <p class="mb-1 l-h-1-31 f-12">Please connect the Listing Agent calendar.</p>
          <button *ngIf="!emailConnected" class="btn btn-primary" (click)="showConnectBtns = true">Connect Calendar</button>
          <ng-container *ngIf="!emailConnected && showConnectBtns">
            <div class="d-flex align-items-center">
              <a href="javascript:void(0)" (click)="gSuiteLogin()" class="_primary-btn d-flex align-items-center"> G Suite </a>
            </div>
          </ng-container>
        </div>
      </div>
    </div>

    <div class="create_box" *ngIf="emailConnected">
      <h3 class="table-title">Create New Appointment</h3>
      <div class="flex_row">
        <label for="">
          Title
          <input type="text" [(ngModel)]="insert_event.app_title" placeholder="Title" />
        </label>

        <label for="">
          Project
          <ng-select
            [items]="projectList"
            bindLabel="Project_Name"
            bindValue="_id"
            [searchable]="true"
            [multiple]="false"
            [(ngModel)]="insert_event.project"
            placeholder="Project"
            [clearable]="true">
          </ng-select>
        </label>

        <label for="">
          Appointment Type
          <ng-select
            [items]="appointment_type"
            bindLabel="tag_name"
            bindValue="tag_name"
            [searchable]="true"
            [multiple]="false"
            [(ngModel)]="insert_event.app_type"
            placeholder="Appointment Type"
            [clearable]="true">
            <ng-template ng-option-tmp let-item="item">
              <div class="d-flex align-items-center">
                <p [ngStyle]="{ 'background-color': item.background_color }" class="cal-color"></p>
                <p tooltipPosition="top" [pTooltip]="item.tag_name">{{ item.tag_name }}</p>
              </div>
            </ng-template>
          </ng-select>
        </label>
      </div>

      <div class="flex_row mt-3" style="justify-content: space-between !important">
        <p class="fexos">
          <img src="assets/img/Peoples_user-business.svg" alt="" />
          Client
        </p>
        <button class="_view-btn" type="button" (click)="addclient()" pTooltip="Add Client" tooltipPosition="left">
          <i class="pi pi-plus f-12"></i>
        </button>
      </div>

      <div class="row mt-3">
        <ng-container *ngFor="let client of appointment_client; let i = index">
          <div class="col-sm-4  {{ i > 0 && 'mt-2' }}">
            <p class="mb-1">Name</p>
            <label for="" class="w-100">
              <re-multiselect
                [module]="'contacts'"
                [placeholder]="'Select'"
                [truncate]="25"
                [isMultiple]="false"
                [isClear]="true"
                [isFullObject]="true"
                [selected_ids]="client.contactid"
                [ngModelOptions]="{ standalone: true }"
                (onUpdate)="contactSelection($event, i)"
                [style]="{ width: '100%' }">
              </re-multiselect>
            </label>
          </div>
          <div class="col-sm-3  {{ i > 0 && 'mt-2' }} pl-0">
            <p class="mb-1">Mobile</p>
            <input type="text" placeholder="Mobile" [ngModelOptions]="{ standalone: true }" [(ngModel)]="client.mobile_no" />
          </div>
          <div class="col-sm-4  {{ i > 0 && 'mt-2' }} px-0 position-relative">
            <p class="mb-1">Email</p>
            <i class="pi pi-times remove-client" (click)="removeClient(i)"></i>
            <input type="email" placeholder="Email" [ngModelOptions]="{ standalone: true }" [(ngModel)]="client.email" />
          </div>
        </ng-container>
      </div>

      <div class="col-sm-12">
        <div class="form-group">
          <p class="_fw-600 my-2">Guest</p>
          <p-chips [(ngModel)]="attendeeList" [ngModelOptions]="{ standalone: true }" (onAdd)="onAddEmail($event)"></p-chips>
          <small class="px-1 f-10">Press enter after typing tag name</small>
        </div>
      </div>

      <div class="flex_row mt-3">
        <p class="fexos">
          <img [src]="common_images?.email_overview_icon" alt="" />
          Time & Date
        </p>
      </div>

      <div class="flex_row mt-2">
        <label style="width: 100px; margin-top: 10px"
          >Pick a Date
          <p-calendar
            hourFormat="12"
            [firstDayOfWeek]="1"
            [(ngModel)]="insert_event.startdate"
            dateFormat="dd/mm/yy"
            inputId="basic"
            placeholder="DD-MM-YY">
          </p-calendar>
        </label>

        <div style="width: 210px; margin-top: 10px">
          <div style="display: flex; flex-direction: column">
            <p class="mb-1 pl-0" style="line-height: 1.5">Start Time</p>
            <div class="d-flex gap-2">
              <div class="col-sm-4 pl-0" style="width: 60px">
                <ng-select
                  [(ngModel)]="selectedStartHour"
                  [clearable]="false"
                  [searchable]="true"
                  placeholder="Hr"
                  [items]="hours"
                  (change)="startHourChange()">
                </ng-select>
              </div>
              <div class="col-sm-4 pl-0" style="width: 65px">
                <ng-select
                  [(ngModel)]="selectedStartMinutes"
                  [clearable]="false"
                  [searchable]="true"
                  placeholder="Min"
                  [items]="minutes"
                  (change)="startMinuteChange()">
                </ng-select>
              </div>
              <div class="col-sm-4 pl-0" style="width: 66px">
                <ng-select
                  [(ngModel)]="selectedStartDuration"
                  [clearable]="false"
                  [searchable]="true"
                  placeholder="AM"
                  [items]="duration"
                  (change)="startHourChange()">
                </ng-select>
              </div>
            </div>
          </div>
        </div>

        <div style="width: 210px; margin-top: 10px">
          <div style="display: flex; flex-direction: column">
            <p class="mb-1 pl-0" style="line-height: 1.5">End Time</p>
            <div class="d-flex gap-2">
              <div class="col-sm-4 pl-0" style="width: 60px">
                <ng-select
                  [(ngModel)]="selectedEndHour"
                  [clearable]="false"
                  [searchable]="true"
                  placeholder="Hr"
                  [items]="hours"
                  (change)="endHourChange()">
                </ng-select>
              </div>
              <div class="col-sm-4 pl-0" style="width: 65px">
                <ng-select
                  [(ngModel)]="selectedEndMinutes"
                  [clearable]="false"
                  [searchable]="true"
                  placeholder="Min"
                  [items]="minutes"
                  (change)="endMinuteChange()">
                </ng-select>
              </div>
              <div class="col-sm-4 pl-0" style="width: 66px">
                <ng-select
                  [(ngModel)]="selectedEndDuration"
                  [clearable]="false"
                  [searchable]="true"
                  placeholder="AM"
                  [items]="duration"
                  (change)="endHourChange()">
                </ng-select>
              </div>
            </div>
          </div>
        </div>
      </div>

      <ng-container *ngIf="emailConnected">
        <div class="flex_row mt-3">
          <p class="fexos">
            <img [src]="common_images?.eye_icon" />
            Visibility
          </p>
        </div>

        <div class="flex_row mt-2">
          <label for="" class="labe">
            Availability
            <ng-select
              class="text-capitalize"
              [items]="availablebusy"
              [(ngModel)]="insert_event.availablebusy"
              bindLabel="name"
              bindValue="name"
              [searchable]="true"
              [multiple]="false"
              placeholder="Busy">
            </ng-select>
          </label>

          <label for="" class="labe">
            Visibility
            <ng-select
              class="text-capitalize"
              [items]="available"
              [(ngModel)]="insert_event.availability"
              bindLabel="name"
              bindValue="name"
              [searchable]="true"
              [multiple]="false"
              placeholder="Availability">
            </ng-select>
          </label>
        </div>
      </ng-container>

      <div class="flex_row mt-3">
        <p class="fexos">
          <img src="assets/headerLogin/note.svg" />
          Note
        </p>
      </div>

      <div class="flex_row mt-2">
        <div class="_paragraph w-100">
          <ckeditor class="c-editor" [(ngModel)]="insert_event.description" data="" [editor]="email_Editor" (ready)="emailEditor($event)"> </ckeditor>
        </div>
      </div>

      <div class="flexCenterEnd mt-2">
        <button (click)="insertEvent()" class="_outline-btn">Save</button>
      </div>
    </div>

    <div class="calander_box" *ngIf="emailConnected">
      <div class="calendar-views d-flex align-items-center justify-content-between pl-0 mb-2">
        <ng-select
          *ngIf="calendarAccessUser?.length > 0"
          [items]="calendarAccessUser"
          bindLabel="full_name"
          bindValue="_id"
          [searchable]="true"
          [multiple]="true"
          [(ngModel)]="activeCalendarUser"
          placeholder="Calendar Access User"
          [clearable]="false"
          class="task-contact _select w-250px"
          (change)="getUserCalendarDetail()">
          <ng-template ng-label-tmp let-item="item">
            <div class="d-flex align-items-center">
              <i class="pi pi-times-circle cursor-pointer mr-2 ml-1" (click)="clear(item?._id, 'calendar'); getUserCalendarDetail()"></i>
              <p class="ng-value-label">{{ item.full_name }}</p>
            </div>
          </ng-template>
          <ng-template ng-option-tmp let-item="item">
            <div class="d-flex align-items-center">
              <p [ngStyle]="{ 'background-color': item.color }" class="cal-color"></p>
              <p>{{ item.full_name }}</p>
            </div>
          </ng-template>
        </ng-select>
        <ng-select
          [items]="calendar_views"
          [searchable]="true"
          [(ngModel)]="lead_cal_view_grid"
          bindLabel="name"
          bindValue="value"
          placeholder="Select"
          [clearable]="false"
          style="width: 90px"
          (change)="leadChangeViewGrid()">
        </ng-select>
      </div>
      <div class="px-0">
        <full-calendar [options]="options_calendar" contentHeight="auto" #fullcalendar></full-calendar>
      </div>
    </div>
  </div>
</div>

<div class="event_popup_modal">
  <p-dialog
    [(visible)]="event_popup"
    [position]="'center'"
    [styleClass]="'noHeader'"
    [showHeader]="false"
    [style]="{ maxWidth: '580px', width: 'calc(100% - 30px)', 'margin-top': '200px' }">
    <div class="row">
      <div class="d-flex justify-content-between">
        <div class="right-box-prop">
          <h6 class="event-title mb-1">{{ event_popup_detail?.summary | split: '|' : 0 }}</h6>
          <p class="f-12">
            {{ event_popup_detail?.start?.dateTime | date: 'EEEE, MMMM dd - hh:mm' }} -
            {{ event_popup_detail?.end?.dateTime | date: 'hh:mm a' }}
          </p>
        </div>
        <img [src]="common_images?.edit_icon" class="cursor-pointer mr-2" width="16px" (click)="editCalendarEvent(event_popup_detail)" />
        <img [src]="common_images?.delete_icon" class="cursor-pointer mr-2" width="16px" (click)="deleteCalendarEvent(event_popup_detail)" />
        <div class="crossiconStyle mr-2 cursor-pointer">
          <img [src]="common_images?.close_icon" class="pencil-cross" width="20px" (click)="event_popup = false" />
        </div>
      </div>
    </div>
    <div class="row">
      <div class="d-flex w-100 mb-2 mt-2 px-0">
        <span class="left-box-second d-flex justify-content-center">
          <i class="pi pi-bars"></i>
        </span>
        <div class="right-box-second">
          <p class="f-12" [innerHtml]="event_popup_detail?.description"></p>
        </div>
      </div>
      <div class="d-flex w-100 px-0">
        <span class="left-box-second d-flex justify-content-center">
          <i class="pi pi-bell"></i>
        </span>
        <div class="right-box-second">
          <p class="f-12">30 minutes before</p>
        </div>
      </div>
      <div class="d-flex w-100 px-0">
        <span class="left-box-second d-flex justify-content-center">
          <i class="pi pi-calendar"></i>
        </span>
        <div class="right-box-second">
          <p class="f-12">
            {{ event_popup_detail?.creator?.full_name ? event_popup_detail?.creator?.full_name : 'Listing' }}
          </p>
        </div>
      </div>
      <div class="d-flex w-100 px-0">
        <span class="left-box-second d-flex justify-content-center">
          <i class="pi pi-lock"></i>
        </span>
        <div class="right-box-second">
          <p class="f-12 text-capitalize">{{ event_popup_detail?.visibility }}</p>
        </div>
      </div>
    </div>
  </p-dialog>
</div>
